import { fetcher } from '@commenda/utils';
import type { AdminChargebeeCustomerConnection } from './useAdminCompanyExternalConnections';

export interface LinkAdminChargebeeCustomerParams {
  companyId: number;
  chargebeeCustomerId: string;
}

export async function linkAdminChargebeeCustomer({
  companyId,
  chargebeeCustomerId,
}: LinkAdminChargebeeCustomerParams): Promise<AdminChargebeeCustomerConnection> {
  const response = await fetcher(
    `admin/companies/${companyId}/external-connections/chargebee/link`,
    {
      method: 'POST',
      body: { chargebeeCustomerId },
    }
  );

  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as {
      message?: unknown;
      error?: unknown;
    } | null;
    const message =
      typeof body?.message === 'string'
        ? body.message
        : Array.isArray(body?.message)
          ? body.message.join(', ')
          : typeof body?.error === 'string'
            ? body.error
            : 'Failed to link Chargebee customer';
    throw new Error(message);
  }

  return response.json();
}
